<template>
    <div>
        <b-button-group size="sm" class="w-100">
            <b-button
                variant="table"
                v-if="checkActionAllow('show')"
                @click="showItem(row.index)"
            >
                <i class="far fa-eye"></i>
            </b-button>
        </b-button-group>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { checkActionAllow } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        methods: {
            showItem(index) {
                this.$emit('universalEmit', 'show', index, '', 'finance')
            },
            checkIfNoDebt() {
                if(this.row.item.sum_payment == 0) {
                    return true
                }
                return false
            },
        }
    }
</script>

